export default __webpack_public_path__ + "static/media/36I-120773_-43971_0.c6879065.jpg";